import Button from 'components/Forms/Button/Button';
import useTranslation from 'next-translate/useTranslation';
import { ArrowIcon } from 'public/svg/IconsSvg';

type NavigateBackButtonProps = {
    onCloseCallback?: () => void;
    testIdentifier?: string;
};

export const NavigateBackButton: FC<NavigateBackButtonProps> = ({ onCloseCallback, testIdentifier }) => {
    const { t } = useTranslation();

    return (
        <Button
            className="order-1 vl:order-0 vl:justify-start"
            data-testid={testIdentifier ? `${testIdentifier}-button-back'` : null}
            size="small"
            type="button"
            onClick={onCloseCallback}
        >
            <ArrowIcon className="h-2.5 w-2.5 rotate-90" />
            {t('Back')}
        </Button>
    );
};
